import moment from 'moment';
import { ProductModel } from '../interfaces/models/ProductModel';
import { SubscriptionModel } from '../interfaces/models/SubscriptionModel';
import { UserSubscription } from '../interfaces/models/UserSubscriptionModel';

export default class Helpers {

    static isOk(status) {
        return status < 400;
    }

    static calculateEndDate(subscription: UserSubscription) {
        const {
            is_trial,
            last_payment_days,
            trial_end_days,
            interval,
            period,
        } = subscription;

        const date = is_trial ?
            moment().add(trial_end_days, 'days') :
            moment().add(interval, period as any).subtract(last_payment_days, 'days').add(1, 'days');

        return date.format('DD/MM/Y');
    }

    static shuffle(array) {
        let currentIndex = array.length;
        let temporaryValue;
        let randomIndex;

        while (0 !== currentIndex) {
            randomIndex = Math.floor(Math.random() * currentIndex);
            currentIndex -= 1;

            temporaryValue = array[currentIndex];
            array[currentIndex] = array[randomIndex];
            array[randomIndex] = temporaryValue;
        }

        return array;
    }

    static getSelectValue(options, value) {
        const result = options.filter(e => e.value === value);

        if (result.length) {
            return result[0];
        }

        return null;
    }

    static getPeriodTitle(item: SubscriptionModel) {
        // return item.period + (item.interval > 1 ? 's' : '');
        return item.period + (item.interval > 1 ? 'Plural' : 'Singular');
    }

    static getSubscriptionTitle(item: SubscriptionModel, translateFunc) {
        const period = translateFunc(Helpers.getPeriodTitle(item));

        return `${item.interval} ${period.charAt(0).toUpperCase() + period.slice(1)}`
    }

    static getMonthsByPeriod(period: string, interval: number) {
        switch (period) {
            case 'month':
                return interval;
            case 'year':
                return interval * 12;
        }
    }

    static sortSubscriptions(subscriptions: SubscriptionModel[] | ProductModel[]) {
        subscriptions.sort((a, b) => {
            if (a.period === 'year' && b.period === 'month') {
                return 1;
            } else if (a.period === b.period) {
                return a.interval > b.interval ? 1 : -1;
            } else {
                return -1;
            }
        });

        return subscriptions;
    }

    static replaceAudioComponents(value) {
        if (!value) {
            return ''
        }

        return value.replace(
            // /<audio controls src="([^"]+)"><\/audio>/ig,
            /<audio(\s?controls(="controls")?)? src="([^"]+)"(\s?controls(="controls")?)?><\/audio>/ig,
            '<i class="triangle-audio"><audio src="$3"></audio></i>');
    }

}
